export default __webpack_public_path__ + "static/media/welcome.0672c4aa.mp4";